// src/components/Footer/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3>DisneyLand Preschool</h3>
              <p>We believe that there is 'unique potential' in every child; and DisneyLand nurtures it.</p>
              <div className="footer-social">
                <a href="#facebook" className="footer-social-link">f</a>
                <a href="#instagram" className="footer-social-link">📷</a>
                <a href="#youtube" className="footer-social-link">▶</a>
                <a href="#twitter" className="footer-social-link">🐦</a>
              </div>
            </div>

            <div className="footer-column">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/gallery">Gallery</Link></li>
                <li><Link to="/admission">Admission</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Our Programs</h4>
              <ul>
                <li>Playgroup (2-3 Years)</li>
                <li>Pre-Nursery (3-4 Years)</li>
                <li>Nursery (4-5 Years)</li>
                <li>Kindergarten (5-6 Years)</li>
                <li>Daycare</li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Contact Info</h4>
              <ul className="contact-list">
                <li>
                  <span className="footer-icon">📍</span>
                  <span>I-386 Govindpuram, Ghaziabad 201013</span>
                </li>
                <li>
                  <span className="footer-icon">📞</span>
                  <span>+91 93502 07576</span>
                </li>
                <li>
                  <span className="footer-icon">✉️</span>
                  <span>disneylandpreschool@gmail.com</span>
                </li>
                <li>
                  <span className="footer-icon">🕐</span>
                  <span>Mon - Sat: 8:00 AM - 6:00 PM</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; 2026 DisneyLand Preschool. All Rights Reserved.</p>
            <div className="footer-bottom-links">
              <a href="#privacy">Privacy Policy</a>
              <span>|</span>
              <a href="#terms">Terms & Conditions</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;